import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import { SetaIconAdd, SetaIconSub } from '../Icons';

const style = {
  submitBox: {
    height: 46,
    width: 30,
    backgroundColor: '#FFFFFF',
    marginTop: -9,
    marginBottom: 20,
    marginRight: 10,
  },
  submitButton: {
    width: '100%',
    height: 23,
    marginLeft: 4,
    backgroundColor: 'transparent',
    outline: 'none',
    border: '1px solid #E3E7E8',
    cursor: 'pointer',

    '&:active': {
      borderColor: '#b5b5b5',
    }
  },
  submitAdd: {
    extend: 'submitButton',
    borderTopLeftRadius: 14,
    borderTopRightRadius: 14,
  },
  submitSub: {
    extend: 'submitButton',
    borderBottomLeftRadius: 14,
    borderBottomRightRadius: 14,
  },
};

const Button = ({ classes, onValueAdd, onValueSub }) => (
  <div className={classes.submitBox}>
    <button className={classes.submitAdd} type="button" onClick={onValueAdd}>
      <SetaIconAdd />
    </button>
    <button className={classes.submitSub} type="button" onClick={onValueSub}>
      <SetaIconSub />
    </button>
  </div>
);

Button.propTypes = {
  classes: PropTypes.object.isRequired,
  onValueAdd: PropTypes.func.isRequired,
  onValueSub: PropTypes.func.isRequired,
};

export default injectSheet(style)(Button);
